import React from 'react';
import { PostHogProvider } from '@posthog/react';

const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_POSTHOG_HOST || 'https://app.posthog.com';

// Debug logging
if (process.env.NODE_ENV === 'development') {
  console.log('PostHog Setup:', {
    hasKey: !!posthogKey,
    keyLength: posthogKey?.length || 0,
    keyPreview: posthogKey ? `${posthogKey.substring(0, 10)}...` : 'none',
    host: posthogHost,
  });
}

// Get PostHog Provider component with configuration
export const getPostHogProvider = () => {
  if (!posthogKey) {
    return null;
  }
 // remove the console after workflow setup is done
  console.log('PostHog Setup:')
  console.log('PostHog Key');
  console.log("PostHog Host");
  console.log("PostHog Key Length");

  return ({ children }) => (
    <PostHogProvider
      apiKey={posthogKey}
      options={{
        api_host: posthogHost,
        autocapture: true,
        capture_pageview: false, // We handle this manually
        capture_pageleave: true,
        loaded: (ph) => {
          if (process.env.NODE_ENV === 'development') {
            console.log('✅ PostHog loaded via Provider!', ph);
            // Test capture
            ph.capture('posthog_provider_init', { method: 'provider' });
          }
        },
      }}
    >
      {children}
    </PostHogProvider>
  );
};

export { posthogKey, posthogHost };

